/**
 * ReportKpiRow
 *
 * Gradient KPI cards for the Reports tabs. Same card treatment as
 * UtilizationKpiCards so the two surfaces read as one system; this one takes
 * its cards as data rather than hardcoding a fixed four.
 */

import { KPI_CARD_STYLES } from "../../config/dashboardTheme";

export type KpiGradient = keyof typeof KPI_CARD_STYLES;

export interface KpiCardSpec {
	label: string;
	value: string;
	suffix?: string;
	gradient: KpiGradient;
}

interface ReportKpiRowProps {
	cards: KpiCardSpec[];
}

function KpiCard({ label, value, suffix, gradient }: KpiCardSpec) {
	return (
		<div
			className={`relative overflow-hidden rounded-xl border-0 shadow-lg bg-gradient-to-br ${KPI_CARD_STYLES[gradient]} p-4 min-w-[150px]`}
		>
			<div className="absolute top-0 right-0 w-20 h-20 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
			<p className="text-xs font-medium text-white/70 mb-1">{label}</p>
			<p className="text-2xl font-bold text-white">
				{value}
				{suffix && (
					<span className="text-sm font-normal text-white/70 ml-1">
						{suffix}
					</span>
				)}
			</p>
		</div>
	);
}

export default function ReportKpiRow({ cards }: ReportKpiRowProps) {
	return (
		<div className="flex flex-wrap gap-3">
			{cards.map((c) => (
				<KpiCard key={c.label} {...c} />
			))}
		</div>
	);
}
